<template>
    <div>
        <transition name="modal">
            <div class="modal" style="display: block">
                <div class="modal-dialog modal-lg" role="document">
                    <form @submit.prevent="onSubmit()">
                        <div class="modal-content">
                            <div class="modal-header  abtg__header-modal">


                                <h5 class="modal-title abtg__modal-title" id="exampleModalLabel2">
                                    {{$t('team.insert_new_team')}}</h5>

                                <div class="tools">
                                    <div class="abtg__close-button"><a data-dismiss="modal" @click="closeModal()"><i
                                            class="fas fa-times"></i></a></div>

                                </div>

                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="onSubmit()" class="">
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-lg-6 col-xs-12">
                                                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                                    <input class="mdl-textfield__input abtg__input" name="name"
                                                           type="text"
                                                           v-model="formData.name"

                                                    >
                                                    <label class="mdl-textfield__label">{{$t('team.name')}}</label>
                                                    <p class="text-danger small" v-if="myErrors.name">
                                                        {{myErrors.name[0]}}</p>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-xs-12">
                                                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">

                                                    <input class="mdl-textfield__input abtg__input" name="profession"
                                                           type="text"
                                                           v-model="formData.profession"

                                                    >
                                                    <label class="mdl-textfield__label">{{$t('team.profession')}}</label>
                                                    <p class="text-danger small" v-if="myErrors.profession">
                                                        {{myErrors.profession[0]}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 col-xs-12">
                                                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                                    <input class="mdl-textfield__input abtg__input" name="email"
                                                           type="text"
                                                           v-model="formData.email"
                                                    >
                                                    <label class="mdl-textfield__label">{{$t('team.email')}}</label>
                                                    <p class="text-danger small" v-if="myErrors.email">
                                                        {{myErrors.email[0]}}</p>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-xs-12">
                                                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">

                                                    <input class="mdl-textfield__input abtg__input" name="password"
                                                           type="password"
                                                           v-model="formData.password"
                                                    >
                                                    <label class="mdl-textfield__label">{{$t('team.password')}}</label>

                                                    <p class="text-danger small" v-if="myErrors.password">
                                                        {{myErrors.password[0]}}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">

                                                    <input class="mdl-textfield__input abtg__input" name="phone"
                                                           type="text"
                                                           v-model="formData.phone"
                                                    >
                                                    <label class="mdl-textfield__label">{{$t('team.phone')}}</label>
                                                    <p class="text-danger small" v-if="myErrors.phone">
                                                        {{myErrors.phone[0]}}</p>
                                                </div>
                                            </div>
                                        </div>


                                        <div v-if="1 == 2">
                                            <div class="row">
                                                <div class="col">
                                                    <p>Cosa vuoi condividere con questo collaboratore?</p>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-12">
                                                    <h4>Operazioni</h4>


                                                    <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
                                                           v-for="m in modules"
                                                    >
                                                        <input type="checkbox" class="mdl-checkbox__input" name="modulo"
                                                               @click="hideOperation(m.id)"
                                                               v-model="p_modules"
                                                               :value="m.id"
                                                        >
                                                        <span class="mdl-checkbox__label">{{m.label}}</span>
                                                    </label>


                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-12">
                                                    <h4>Singole operazioni</h4>

                                                    <h6>Aste</h6>
                                                    <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
                                                           v-for="(d, index) in operationListAuction">

                                                        <input type="checkbox" class="mdl-checkbox__input"
                                                               name="operazione"
                                                               v-model="p_operations"
                                                               :value="d.id"
                                                        >
                                                        <span class="mdl-checkbox__label">{{d.via}} {{d.id}}<span
                                                                v-if="d.custom === 1">(custom)</span></span>
                                                    </label>
                                                    <hr>
                                                    <h6>Mercato Libero</h6>

                                                    <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
                                                           v-for="(d, index) in operationListMapping">
                                                        <input type="checkbox" class="mdl-checkbox__input"
                                                               name="operazione"
                                                               v-model="p_operations"
                                                               :value="d.id"
                                                        >
                                                        <span class="mdl-checkbox__label">{{d.via}} {{d.id}}<span
                                                                v-if="d.custom === 1">(M.Libero)</span></span>
                                                    </label>


                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-12">
                                                    <h4>Schede dell'operazione</h4>
                                                    <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
                                                           v-for="(c, index) in cards" :key="c.id">
                                                        <input type="checkbox" class="mdl-checkbox__input" name="scheda"
                                                               v-model="p_cards"
                                                               :value="c.id"
                                                        >
                                                        <span class="mdl-checkbox__label"> {{c.label}}</span>
                                                    </label>


                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <button type="submit"
                                                        class="  margin-right-10 btn-success float-right abtg__btn-star"

                                                >

                                                    {{$t('team.salva')}}
                                                </button>

                                            </div>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div class="modal-footer">

                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </transition>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'team/getField',
        mutationType: 'team/updateField',
    });

    export default {
        mixins: [mixin],

        data: function () {
            return {

                mappingCheck: false,
                auctionCheck: false,

            }
        },

        computed: {
            ...mapFields([
                'formData',
                'myErrors',
                'operationListAuction',
                'operationListMapping',
                'default_modules',
                'p_modules',
                'modules',
                'p_operations',
                'p_cards',
                'default_cards',
                'cards',
            ]),
            myErrors: function () {
                return this.$store.state.team.myErrors;
            },
            teamList: function () {

            }
        },
        created: function () {
            this.clearForm();
        },
        methods: {
            clearForm: function () {
                this.$store.dispatch('team/clearForm');
            },

            hideOperation: function (type) {
                let take = 1;

                if ((type === 1 || type === 3) && this.operationListMapping.length > 0) {
                    this.operationListMapping = [];
                    take = 0;
                }

                if (type === 2 && this.operationListAuction.length > 0) {
                    this.operationListAuction = [];
                    take = 0;
                }

                if (take === 1) {
                    this.$store.dispatch('team/operationList', {type: type});
                }
            },


            onSubmit: function () {
                this.$store.dispatch('team/save');
            },

            closeModal: function () {
                this.$store.dispatch('team/clearError');
                this.$parent.triggerShowHideModalCreate();
            }

        }
    }
</script>
